import { yupResolver } from "@hookform/resolvers/yup";

import { yup } from "helpers/yup";

const schema = yup.object({
  zipCode: yup.string().length(8).required(),
  address: yup.string().min(3).required(),
  neighborhood: yup.string().min(3).required(),
  address2: yup.string().optional(),
  city: yup.string().min(3).required(),
  number: yup.string().max(6).required(),
  state: yup.string().length(2).required(),
  ibgeCode: yup.string().required(),
});

export const schemaResolver = yupResolver(schema);
